<template>
  <div>
    <section class="page-not-found">
      <div class="container">
        <div class="row cRow">
          <div class="col-sm-7">
            <img :src="cdn + '/images/404.png'" class="img-responsive" alt="" />
          </div>
          <!-- /.col-sm-7 -->
          <div class="col-sm-5">
            <div class="pnf-content">
              <div class="big-text">401</div>
              <h1>Oops!</h1>
              <p>
                Seems like the page you are looking for is being made on a faraway island.
              </p>
              <router-link to="/">
                <div class="btn btn-primary">Back to Home</div>
              </router-link>
            </div>
            <!-- /.pnf-content -->
          </div>
          <!-- /.col-sm-5 -->
        </div>
        <!-- /.row -->
      </div>
    </section>
  </div>
</template>

<script>
export default {
  computed: {
    cdn: function () {
      return process.env.VUE_APP_CDN;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/shared/401.vue